import React, { useEffect, useRef, useState } from "react";

function DeFiPlatforms() {
  const shapeRef = useRef(null);
  const [offsetY, setOffsetY] = useState(0);

  useEffect(() => {
    const handleScroll = () => {
      if (!shapeRef.current) return;

      const rect = shapeRef.current.getBoundingClientRect();
      const windowHeight = window.innerHeight;

      // Check if element is in viewport
      if (rect.top < windowHeight && rect.bottom > 0) {
        const scrollProgress = rect.top / windowHeight;
        setOffsetY(scrollProgress * 500); // adjust speed here
      }
    };

    window.addEventListener("scroll", handleScroll);
    handleScroll(); // run once

    return () => window.removeEventListener("scroll", handleScroll);
  }, []);
  return (
    <>
      <div className="team-style-two-area default-padding bottom-less">
        <div className="container">
          <div className="team-style-two-items">
            <div className="shape" ref={shapeRef}>
              <img
                src="https://validthemes.net/site-template/robok/assets/img/illustration/9.png"
                alt="Image Not Found"
                style={{
                  transform: `translateY(${offsetY}px)`,
                  transition: "transform 0.1s linear",
                }}
              />
            </div>
            <div className="row align-center">
              {/* Start Team Item */}
              <div className="col-lg-6 col-md-6 mb-30">
                <div className="team-style-two-heading">
                  <h4 className="sub-title">Ai Developer</h4>
                  <h2 className="title split-text-right split-text-in-right">
                    Application Range with Substrate Blockchain Technology
                  </h2>
                </div>
              </div>

              <div className="col-lg-3 col-md-6 mb-30">
                <div className="team-style-two-item fade-up-anim">
                  <div className="thumb">
                    <img
                      src="https://validthemes.net/site-template/robok/assets/img/team/5.jpg"
                      alt="Image Not Found"
                    />
                  </div>
                  <div className="info">
                    <h4>DeFi Platforms</h4>
                    {/* <span>Ai Programmer</span> */}
                  </div>
                </div>
              </div>

              <div className="col-lg-3 col-md-6 mb-30">
                <div className="team-style-two-item fade-up-anim">
                  <div className="thumb">
                    <img
                      src="https://validthemes.net/site-template/robok/assets/img/team/6.jpg"
                      alt="Image Not Found"
                    />
                  </div>
                  <div className="info">
                    <h4>Supply Chain Management Systems</h4>
                    {/* <span>Data Analyst</span> */}
                  </div>
                </div>
              </div>

              <div className="col-lg-3 col-md-6 mb-30">
                <div className="team-style-two-item fade-up-anim">
                  <div className="thumb">
                    <img
                      src="https://validthemes.net/site-template/robok/assets/img/team/7.jpg"
                      alt="Image Not Found"
                    />
                  </div>
                  <div className="info">
                    <h4>Voting and Governance Solutions</h4>
                    {/* <span>Robotics Engineer</span> */}
                  </div>
                </div>
              </div>

              <div className="col-lg-3 col-md-6 mb-30">
                <div className="team-style-two-item fade-up-anim">
                  <div className="thumb">
                    <img
                      src="https://validthemes.net/site-template/robok/assets/img/team/8.jpg"
                      alt="Image Not Found"
                    />
                  </div>
                  <div className="info">
                    <h4>Identity and Access Management Systems</h4>
                    {/* <span>Data Collector</span> */}
                  </div>
                </div>
              </div>

              <div className="col-lg-3 col-md-6 mb-30">
                <div className="team-style-two-item fade-up-anim">
                  <div className="thumb">
                    <img
                      src="https://validthemes.net/site-template/robok/assets/img/team/9.jpg"
                      alt="Image Not Found"
                    />
                  </div>
                  <div className="info">
                    <h4>Gaming and Gambling Platforms</h4>
                    {/* <span>Language Specialist</span> */}
                  </div>
                </div>
              </div>
              <div className="col-lg-3 col-md-6 mb-30">
                <div className="team-style-two-item fade-up-anim">
                  <div className="thumb">
                    <img
                      src="https://validthemes.net/site-template/robok/assets/img/team/10.jpg"
                      alt="Image Not Found"
                    />
                  </div>
                  <div className="info">
                    <h4>Social Media and Content Sharing Networks</h4>
                    {/* <span>Language Specialist</span> */}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default DeFiPlatforms;
